<div
    [ngClass]="show ? 'd-block' : 'd-none'"
    class="modal-backdrop fade show"
></div>
<ng-content></ng-content>
